import cn from 'classnames';
import React, {FC} from 'react';
import styles from './Animoji.module.css';
import images from './images';

export type AnimojiNames = keyof typeof images;

export interface AnimojiProps {
	name: AnimojiNames;
	className?: string;
}

export const Animoji: FC<AnimojiProps> = ({name, className}) => {
	const image = images[name];

	return (
		<div className={cn('relative overflow-hidden', className)}>
			<div
				className={cn('w-full h-full bg-cover', styles.inner)}
				style={{backgroundImage: `url(${typeof image === 'string' ? image : (image as {src: string}).src})`}}
			/>
		</div>
	);
};
